import Breadcrumb from "../Pages/Breadcrumb";
import Image from "../ui/Image";
import { Link } from "react-router-dom";
import useHomeSection from "../../hooks/useHomeSection";
import { useTranslation } from "react-i18next";

const Achievements = () => {
    const { t } = useTranslation();
    const { data: achievements, error, isLoading } = useHomeSection({ sectionName: 'ivory_Achievements' });
    document.title = `${t('routes.achievements')} | ${t('ivory')}`;

    if (error) {
        <div className="flex justify-center items-center relative z-50 bg-white">
            <p id="err">{error?.message || t('custom.err')}</p>
        </div>
    };

    if (isLoading) {
        return (
            <>
                <div className="h-10 w-full l-load-dt my-2"></div>
                <main className="px-20 py-8 max-lg:px-4  grid grid-cols-3 gap-4 max-xl:grid-cols-2 max-lg:grid-cols-1 w-full">
                    {
                        [...Array(6)].map((_, i) => (
                            <div key={i} className="w-full h-72 rounded-lg l-load-dt"></div>
                        ))
                    }
                </main>
            </>
        )
    }
    return (
        <>
            <Breadcrumb pages={[t("routes.achievements")]} />
            <main className="px-20 py-8 max-lg:px-4 grid grid-cols-3 gap-4 max-xl:grid-cols-2 max-lg:grid-cols-1">
                {
                    achievements?.map((achievement, i) => (
                        <Link to={`/achievements/${achievement?.id}`} key={achievement?.id || i} className="border rounded-lg space-y-3 p-2">
                            <div className="relative h-96">
                                <Image
                                    src={achievement?.image}
                                    alt={achievement?.title}
                                    className={'w-full h-full object-cover object-center rounded-lg'}
                                />
                            </div>
                            <div>
                                <p className="text-secondary-tw text-lg">
                                    {achievement?.title}
                                </p>
                            </div>
                        </Link>
                    ))
                }
            </main>
        </>
    );
};

export default Achievements;